import { buildTranslate } from 'locales'
import moment from 'moment-timezone'
import { I18n } from 'react-redux-i18n'

const t = buildTranslate('points.configuration.multipliers.date_range')

function dateRangeText(
  startDate: string | null,
  endDate: string | null,
  month_format?: 'abbreviation' | 'complete'
): string {
  if (!startDate && !endDate) {
    return t('on_any_date')
  }

  if (startDate === endDate) {
    return t('on', {
      date: formatDateString(startDate!, month_format),
    })
  }

  const content: string[] = []
  if (startDate) {
    content.push(
      t('from', {
        date: formatDateString(startDate, month_format),
      })
    )
  }

  if (endDate) {
    content.push(
      t('until', {
        date: formatDateString(endDate, month_format),
      })
    )
  }

  return content.join(' ')
}

export function formatDateString(
  inputDate: string,
  month_format: 'abbreviation' | 'complete' = 'abbreviation'
): string {
  const months = I18n.t(`common.months.${month_format}`)

  const dateParts = inputDate.split('-')
  const year = dateParts[0]
  const month = months[parseInt(dateParts[1]) - 1]
  const day = parseInt(dateParts[2])

  return `${month} ${day}, ${year}`
}

function formatFactor(factor: number) {
  return Number(factor)
    .toFixed(2)
    .replace(/\.?0+$/, '')
}

export { formatFactor, dateRangeText }

// The backend enforces multiplier date ranges against the current day in
// Pacific Time for every location, regardless of the location's own zone
// (per-location enforcement is LOY-337).
const MULTIPLIER_TIME_ZONE = 'America/Los_Angeles'

// Today's date (YYYY-MM-DD) in the zone multiplier dates are enforced in, so
// the dashboard agrees with enforcement whatever the browser's zone is.
export function multiplierToday(): string {
  return moment.tz(MULTIPLIER_TIME_ZONE).format('YYYY-MM-DD')
}

// Multiplier dates are plain YYYY-MM-DD strings, which order correctly when
// compared as strings.
export function isTodayWithinRange(
  startsOn?: string | null,
  endsOn?: string | null
): 'within' | 'past' | 'future' {
  const today = multiplierToday()

  if (startsOn && today < startsOn) return 'future'
  if (endsOn && today > endsOn) return 'past'
  return 'within'
}

// The earliest end date the form allows: the later of the saved start date
// and today in Pacific Time.
export function minEndDate(startsOn?: string | null): string {
  const today = multiplierToday()
  return startsOn && startsOn > today ? startsOn : today
}
